import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestStorage from './RequestStorage';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, requests, newRequest, error, message,
  } = state.request;
  return {
    isLoading,
    requests,
    newRequest,
    error,
    message,
  };
}

const Styled = withStyles(styles)(RequestStorage);

export default connect(
  mapStateToProps,
)(Styled);
